<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1536"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1540"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1550"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1548" /></clipPath></defs><g
     id="g1542"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1544"><g
         id="g1546"
         clip-path="url(#clipPath1550)"><g
           id="g1552"
           transform="translate(443,87.8301)"><path
             d="m 0,0 v -60.33 c 0,-11.046 -8.954,-20 -20,-20 h -334 c -11.046,0 -20,8.954 -20,20 v 339.679"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1554" /></g><g
           id="g1556"
           transform="translate(385.0322,504.5)"><path
             d="m 0,0 h 37.968 c 11.046,0 20,-8.954 20,-20 v -361.228"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1558" /></g><g
           id="g1560"
           transform="translate(69,403.7363)"><path
             d="m 0,0 v 80.764 c 0,11.046 8.954,20 20,20 h 261.148"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1562" /></g><g
           id="g1564"
           transform="translate(402,352.0801)"><path
             d="m 0,0 c 0,-27.614 -22.386,-50 -50,-50 -27.614,0 -50,22.386 -50,50 0,27.614 22.386,50 50,50 C -22.386,50 0,27.614 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1566" /></g><g
           id="g1568"
           transform="translate(330.5034,349.1602)"><path
             d="M 0,0 21.174,-11.372 40.027,17.739"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1570" /></g><g
           id="g1572"
           transform="translate(402,221.0029)"><path
             d="m 0,0 c 0,-27.614 -22.386,-50 -50,-50 -27.614,0 -50,22.386 -50,50 0,27.614 22.386,50 50,50 C -22.386,50 0,27.614 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1574" /></g><g
           id="g1576"
           transform="translate(330.5034,218.0835)"><path
             d="M 0,0 21.174,-11.372 40.027,17.739"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1578" /></g><g
           id="g1580"
           transform="translate(402,89.9263)"><path
             d="m 0,0 c 0,-27.614 -22.386,-50 -50,-50 -27.614,0 -50,22.386 -50,50 0,27.614 22.386,50 50,50 C -22.386,50 0,27.614 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1582" /></g><g
           id="g1584"
           transform="translate(330.5034,87.0063)"><path
             d="M 0,0 21.174,-11.372 40.027,17.739"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1586" /></g><g
           id="g1588"
           transform="translate(70.7539,435)"><path
             d="M 0,0 H 370.511"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1590" /></g><g
           id="g1592"
           transform="translate(118.231,370.7241)"><path
             d="M 0,0 H 120"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1594" /></g><g
           id="g1596"
           transform="translate(118.231,333.436)"><path
             d="M 0,0 H 60"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1598" /></g><g
           id="g1600"
           transform="translate(118.231,239.9111)"><path
             d="M 0,0 H 120"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1602" /></g><g
           id="g1604"
           transform="translate(118.231,202.623)"><path
             d="M 0,0 H 60"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1606" /></g><g
           id="g1608"
           transform="translate(118.231,109.0986)"><path
             d="M 0,0 H 120"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1610" /></g><g
           id="g1612"
           transform="translate(118.231,71.8105)"><path
             d="M 0,0 H 60"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1614" /></g></g></g></g></svg>
</template>
